import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { MoreHorizontal } from 'react-feather'
import { Invoice } from '../../../../back-end/common/invoice'
import { AppContext } from '../../App'
import * as Permission from '../../constants/permission'

interface InvoiceActionProps {
	invoice: Invoice
	handleSubmitApproval: (invoice: Invoice) => void
	handleApprove: (invoice: Invoice) => void
	handleSendToClient: (invoice: Invoice, emailToClient: boolean) => void
	handleDelete: (invoice: Invoice) => void
	handleVoid: (invoice: Invoice) => void
}

export const canSubmitForApproval = [Permission.Admin, Permission.CadetInterSenior, Permission.Director, Permission.ExecAssistant, Permission.SupervisorManager]
export const canApprove = [Permission.Admin, Permission.Director, Permission.ExecAssistant]
export const canSendToContact = [Permission.Admin, Permission.Director, Permission.SupervisorManager, Permission.ExecAssistant]
export const canDelete = [Permission.Admin, Permission.CadetInterSenior, Permission.Director, Permission.ExecAssistant, Permission.SupervisorManager]
export const canVoid = [Permission.Admin]

const InvoiceAction = (props: InvoiceActionProps) => {
	const { appState } = React.useContext(AppContext)
	const role = appState.permission.roleID
	return (
		<Dropdown>
			<Dropdown.Toggle as="div" className="line-options-toggle">
				<MoreHorizontal size={20} />
			</Dropdown.Toggle>
			<Dropdown.Menu>
				{props.invoice.status === 'DRAFT' && canSubmitForApproval.includes(role) && (
					<Dropdown.Item onClick={() => props.handleSubmitApproval(props.invoice)}>Submit for approval</Dropdown.Item>
				)}
				{props.invoice.status === 'SUBMITTED' && canApprove.includes(role) && (
					<Dropdown.Item onClick={() => props.handleApprove(props.invoice)}>Approve</Dropdown.Item>
				)}
				{props.invoice.status === 'AUTHORISED' && props.invoice.sentToContact === false && canSendToContact.includes(role) && (
					<>
						<Dropdown.Item onClick={() => props.handleSendToClient(props.invoice, true)}>Email to Contact</Dropdown.Item>
						<Dropdown.Item onClick={() => props.handleSendToClient(props.invoice, false)}>Mark as Sent</Dropdown.Item>
					</>
				)}
				{((props.invoice.status === 'DRAFT' && canDelete.includes(role)) || (props.invoice.status === 'SUBMITTED' && canVoid.includes(role))) && (
					<Dropdown.Divider />
				)}
				{(props.invoice.status === 'DRAFT' || props.invoice.status === 'SUBMITTED') && canDelete.includes(role) && (
					<Dropdown.Item onClick={() => props.handleDelete(props.invoice)}>Delete</Dropdown.Item>
				)}
				{props.invoice.status === 'AUTHORISED' && canVoid.includes(role) && (
					<Dropdown.Item onClick={() => props.handleVoid(props.invoice)}>Void</Dropdown.Item>
				)}
			</Dropdown.Menu>
		</Dropdown>
	)
}

export default InvoiceAction
